"use client";

import * as React from "react";
import { ExploreCardFrame } from "./ExploreCardFrame";

export interface ExploreEmptyStateV2Props {
  children: React.ReactNode;
}

export function ExploreEmptyStateV2({ children }: ExploreEmptyStateV2Props) {
  return (
    <ExploreCardFrame>
      <div className="mt-2 p-4 sm:p-6">{children}</div>
    </ExploreCardFrame>
  );
}
